import { Bookmark } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconBookmark12Line = createIcon(Bookmark, 12, "Line");
export const IconBookmark16Line = createIcon(Bookmark, 16, "Line");
export const IconBookmark20Line = createIcon(Bookmark, 20, "Line");
export const IconBookmark24Line = createIcon(Bookmark, 24, "Line");
export const IconBookmark32Line = createIcon(Bookmark, 32, "Line");
export const IconBookmark48Line = createIcon(Bookmark, 48, "Line");
export const IconBookmark64Line = createIcon(Bookmark, 64, "Line");
